import ToolbarButton from 'hb-react/shared/components/DesignSystem/QuillEditor/Toolbar/components/ToolbarButton';

const ListOrdered = () => (
  <ToolbarButton
    key="list-numbered"
    className="ql-list"
    value="ordered"
    text={__('Numbered list')}
    iconName="list-ol"
    dataTestId="toolbar-list-ordered"
  />
);

export default ListOrdered;
